<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">

                <!-- Header Meta !-->
                <table-meta-element
                    :hide-nav="true"
                    :hide-nav-on-no-pages="false"
                    title="Settlements"
                    item-type="settlements"
                    :show-loading="true"
                >
                    <div slot="title" class="dropdown" style="display: inline-block;">
                        <title-view-selector
                            :title="title"
                            :options="viewOptions"
                            @select="viewSelected"
                        ></title-view-selector>
                    </div>
                </table-meta-element>

                <!-- Instance Table !-->
                <table class="table finance-table">
                    <thead v-if="tableHeaderColumns.length > 0">
                        <th v-for="column in tableHeaderColumns" :key="column.label" :style="column.style ? column.style : ''">{{ column.label }}</th>
                    </thead>
                    <tbody v-if="hasResults">
                        <tr v-for="(instance, index) in results.results" :key="instance.id">
                            <td class="truncate">
                                <div v-if="instance" style="font-size: .8rem">
                                    <a :href="$root.buildUrl('vehicles/' + instance.id + '/overview')" class="registration" style="display: inline-block; margin-top: 5px; font-size: .7em; width: 60px; margin-right: 10px; padding: .45em 0; color: #42526e; font-weight: 500;">{{ instance.vehicle.registration.formatted_vrm }}</a><a v-if="instance" :href="$root.buildUrl('vehicles/' + instance.id + '/overview')" style="vertical-align: middle;">{{ instance.title }}</a>
                                </div>
                                <div class="mt-1">
                                    <a v-if="instance.purchase_cost" :href="'/contacts/' + instance.purchase_cost.expense.contact_id">{{ instance.purchase_cost.expense.contact.primary_display_as }}</a>
                                    <span class="subtle" v-else>No Purchase Cost</span>
                                </div>
                            </td>
                            <td>
                                <span v-if="instance.purchased_at">{{ formatDate(instance.purchased_at, 'DD/MM/YYYY') }}</span>
                                <span v-else class="subtle">-</span>
                            </td>
                            <td>
                                <a v-if="instance.part_exchange_record" :href="'/deals/' + instance.part_exchange_record.deal_id + '/edit'">#{{ instance.part_exchange_record.deal_id }}</a>
                            </td>
                            <td>
                                <div v-if="instance.finance_settlement.finance_company">{{ instance.finance_settlement.finance_company.primary_display_as }}</div>
                                <span class="subtle" v-else>-</span>
                            </td>
                            <td class="truncate">
                                {{ instance.finance_settlement.agreement_number }}
                            </td>
                            <td>
                                {{ instance.finance_settlement.amount | currency(2) }}
                            </td>
                            <td>
                                <span v-if="instance.finance_settlement.due_at">
                                    {{ instance.finance_settlement.due_at | formatDate('DD/MM/YYYY') }}
                                </span>
                                <span v-else class="subtle">-</span>
                            </td>
                            <td class="text-center">
                                <ui-icon v-if="instance.finance_settlement.contra.id" icon="check" style="color: green;"></ui-icon>
                                <span v-else class="subtle">-</span>
                            </td>
                            <td>
                                <span v-if="instance.finance_settlement.payment_method">
                                    {{ instance.finance_settlement.payment_method | titleCase }}
                                </span>
                                <span v-else class="subtle">-</span>
                            </td>
                            <td>
                                <span v-if="instance.finance_settlement.paid_at">
                                    {{ instance.finance_settlement.paid_at | formatDate('DD/MM/YYYY') }}
                                </span>
                                <span v-else class="subtle">-</span>
                            </td>
                            <td>
                                <ui-icon-button @click="editSettlement(instance)" icon="edit"></ui-icon-button>
                            </td>
                        </tr>
                    </tbody>
                    <tr v-if="!hasResults || results.total === 0">
                        <td colspan="11" class="text-center">No settlements found</td>
                    </tr>
                    <tfoot>
                        <tr>
                            <td colspan="5"><strong>{{ totalCount }} settlements</strong></td>
                            <td><strong>{{ totalDue | currency(2) }}</strong></td>
                            <td colspan="5"></td>
                        </tr>
                    </tfoot>
                </table>

                <!-- Footer Meta !-->
                <table-meta-element
                    :hide-on-no-pages="true"
                    item-type="settlements"
                    style="margin-top: 2rem;"
                ></table-meta-element>
            </div>
        </div>

        <!-- Finance Settlement Modal !-->
        <finance-settlement-modal ref="modal" @saved="handleSaved"></finance-settlement-modal>
    </div>
</template>
<script>
    import DataView from '../../../components/mixins/DataView';
    import { mapState, mapActions } from 'vuex'
    import {VehicleInstanceResource} from "../../../classes/Api/Vehicle";
    import FinanceSettlementModal from "./FinanceSettlementModal.vue";
    import {sumBy} from "lodash";
    import formatDate from "../../../filters/date/format";

    export default {
        components: {FinanceSettlementModal},
        mixins: [DataView],
        created() {
            this.setResourceRelations([
                'financeSettlement',
                'partExchangeRecord',
            ]);

            this.setFilter({
                key: 'instance.has_settlement',
                value: 'unpaid',
            })

            this.setDefaultSortOrder('id DESC');

            this.setNamespacesToLoad(['settlements']);

            this.setResourceAndLoad(VehicleInstanceResource);
        },
        methods: {
            formatDate,
            ...mapActions({
                get: 'dataView/get'
            }),
            editSettlement(instance) {
                this.$refs.modal.setStockListing(instance)
                this.$refs.modal.open(instance.finance_settlement.id)
            },
            handleSaved(settlement) {
                this.get()
            },
        },
        computed: {
            ...mapState({
                title: state => state.dataView.title,
                currentFilters: state => state.dataView.currentFilters,
            }),
            totalCount() {
                return this.results ? this.results.results.length : 0
            },
            totalDue() {
                return this.results ? sumBy(this.results.results, 'finance_settlement.amount') : 0
            },
            viewOptions() {
                return [
                    {
                        label:'Un-Paid',
                        filters: {
                            'instance.has_settlement': 'unpaid'
                        },
                        sort: 'id DESC'
                    },
                    {
                        label:'Paid',
                        filters: {
                            'instance.has_settlement': 'paid'
                        },
                        sort: 'id DESC'
                    },
                    {
                        label:'Any',
                        filters: {
                            'instance.has_settlement': 'any'
                        },
                        sort: 'id DESC'
                    }
                ].concat(this.savedViewMenuOptions);
            },
            tableHeaderColumns() {
                return [
                    { label: 'Vehicle / Purchased From', style: 'width: 20%;' },
                    { label: 'Purchased' },
                    { label: 'Deal #', style: 'width: 90px;' },
                    { label: 'Finance Company', style: 'width: 12%;' },
                    { label: 'Ref #', },
                    { label: 'Settlement £\'s', style: 'width: 130px;' },
                    { label: 'Due Date' },
                    { label: 'Contra', style: 'width: 80px; text-align: center;' },
                    { label: 'P. Method' },
                    { label: 'P. Date' },
                    { label: '', style: 'width: 60px;' },
                ];
            },
        }
    }
</script>